module.exports = __webpack_public_path__ + "img/list_Story_30.79d682f5.jpeg";